// src/pages/personal/settings/ApplicationPage.tsx
import React from 'react';
import { AdaptiveLayout } from '@/components/ui/Layout';
import SettingsSection from './SettingsSection/SettingsSection';

const ApplicationPage: React.FC = () => {
  return (
    <AdaptiveLayout>
      <SettingsSection />
    </AdaptiveLayout>
  );
};

export default ApplicationPage;